// src/utils/classNames.js

export const cn = (...classes) => {
    return classes.filter(Boolean).join(" ");
};
